import dashboard from '../../src/assets/icon-add-circle.svg';
import layers from '../../src/assets/icon-layers.svg';
import agent from '../../src/assets/icon-agent.svg';
import team from '../../src/assets/icon-team.svg';
import toolsIcon from '../../src/assets/toolsIcon.svg';
import iconAdd from '../../src/assets/icon-add.svg';

export const NavData = [
  {
    path: 'dashboard',
    file: 'new-chat',
    img: dashboard,
    name: 'Kitt Chat',
    haskey: true,
  },
  {
    path: 'create-agent',
    file: 'create-agent',
    img: iconAdd,
    name: 'Create Agent',
    haskey: true,
  },
  {
    path: 'projects',
    file: 'projects',
    img: layers,
    name: 'Projects',
  },
  {
    path: 'agents',
    file: 'agents',
    img: agent,
    name: 'Agents',
  },
  {
    path: 'team',
    file: 'team',
    img: team,
    name: 'Team',
  },
  {
    path: 'tools',
    file: 'tools',
    img: toolsIcon,
    name: 'Tools',
  },
  {
    path: 'workflows',
    file: 'create-workflow',
    img: toolsIcon,
    name: 'Workflows',
  },
  {
    path: 'task-manager',
    file: 'task-manager',
    img: team,
    name: 'Task Manager',
  },
];
